import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { CalendarRange, TrendingUp } from "lucide-react";

export default function ReportingPanel() {
  const [periods, setPeriods] = useState([]);
  const [period, setPeriod] = useState("month");
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/reporting/periods").then(({ data }) => { setPeriods(data.periods); setPeriod(data.default); });
  }, []);

  const load = useCallback(async (p) => {
    const { data } = await api.get(`/reporting/kpis?period=${p}`);
    setData(data);
  }, []);
  useEffect(() => { if (period) load(period); }, [period, load]);

  return (
    <div data-testid="reporting-panel">
      <div className="toolbar">
        <div className="section-label" style={{ margin: 0 }}>
          <CalendarRange size={14} style={{ verticalAlign: "-2px", marginRight: 6 }} /> Executive Reporting
        </div>
        <div className="spacer" />
        <select data-testid="period-selector" className="input" style={{ height: 32 }}
                value={period} onChange={(e) => setPeriod(e.target.value)}>
          {periods.map((p) => <option key={p.key} value={p.key}>{p.label}</option>)}
        </select>
      </div>

      {data && (
        <>
          <div style={{ fontSize: 13, opacity: 0.7, marginBottom: 12 }}>
            <TrendingUp size={13} style={{ verticalAlign: "-1px" }} /> {data.label}
            {data.range.start ? ` · from ${new Date(data.range.start).toLocaleDateString()}` : " · full history"}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 12 }}>
            {data.kpis.map((k) => (
              <div key={k.label} className="card" data-testid={`kpi-${k.label.toLowerCase().replace(/\s/g, "-")}`}>
                <div style={{ fontSize: 12, opacity: 0.6 }}>{k.label}</div>
                <div style={{ fontSize: 26, fontWeight: 700, marginTop: 4 }}>{k.value}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
